var _circle, _circle2, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#7D77B7",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 42.9545,
    fill: "#7D77B7",
    fillOpacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5,
    cy: 52.4999,
    rx: 33.4091,
    ry: 33.4091,
    fill: "#ECE3CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8921 52.5C18.8921 33.9369 33.9369 18.8921 52.5 18.8921C71.0632 18.8921 86.108 33.9369 86.108 52.5C86.108 71.0632 71.0632 86.108 52.5 86.108C33.9369 86.108 18.8921 71.0632 18.8921 52.5ZM67.7024 46.6974C69.1333 45.2665 69.1333 42.9297 67.7024 41.4987C66.2714 40.0677 63.9346 40.0677 62.5036 41.4987L48.299 55.7033L42.4964 49.9007C41.0654 48.4697 38.7286 48.4697 37.2977 49.9007C35.8667 51.3316 35.8667 53.6684 37.2977 55.0994L45.6996 63.5014C47.1306 64.9324 49.4674 64.9324 50.8984 63.5014L67.7024 46.6974Z",
    fill: "#7D77B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.36a0608fc68bb82798689a84ebdfae65.svg";
export { ForwardRef as ReactComponent };